export default function FiltersSidebarSkeleton() {
  return (
    <>
      <div className="accordion accordion-filters accordion-flush mt-4 border-0 border-top" id="sidebar-filters">
        <div className="accordion-item">
          <h3 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filter-collection"
              aria-expanded="true"
              aria-controls="filter-collection"
            >
              <span className="animated-placeholder height-md w-40"></span>
            </button>
          </h3>
          <div id="filter-collection" className="accordion-collapse show">
            <div className="accordion-body">
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-70"></span>
                </label>
              </div>
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-80"></span>
                </label>
              </div>
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-60"></span>
                </label>
              </div>
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-70"></span>
                </label>
              </div>
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-50"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h3 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filter-collection"
              aria-expanded="true"
              aria-controls="filter-collection"
            >
              <span className="animated-placeholder height-md w-40"></span>
            </button>
          </h3>
          <div id="filter-collection" className="accordion-collapse show">
            <div className="accordion-body">
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-70"></span>
                </label>
              </div>
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-80"></span>
                </label>
              </div>
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-60"></span>
                </label>
              </div>
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-70"></span>
                </label>
              </div>
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-50"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h3 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filter-collection"
              aria-expanded="true"
              aria-controls="filter-collection"
            >
              <span className="animated-placeholder height-md w-40"></span>
            </button>
          </h3>
          <div id="filter-collection" className="accordion-collapse show">
            <div className="accordion-body">
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-70"></span>
                </label>
              </div>
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-80"></span>
                </label>
              </div>
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-60"></span>
                </label>
              </div>
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-70"></span>
                </label>
              </div>
              <div className="form-check mb-2">
                <input className="form-check-input" type="checkbox" disabled />
                <label className="form-check-label d-block">
                  <span className="animated-placeholder w-50"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
